interface EnvironmentConfig {
  API_URL: string
  ENVIRONMENT: string
  MIXPANEL_TOKEN: string
}

let cachedConfig: EnvironmentConfig | null = null

export async function loadEnvironmentConfig(): Promise<EnvironmentConfig> {
  if (cachedConfig) {
    return cachedConfig
  }

  const config = useRuntimeConfig()
  const environment = config.public.appEnv

  try {
    switch (environment) {
      case 'dev':
        cachedConfig = (await import('./dev.json')).default
        break
      case 'ft':
        cachedConfig = (await import('./ft.json')).default
        break
      case 'prod':
        cachedConfig = (await import('./prod.json')).default
        break
      default:
        cachedConfig = (await import('./prod.json')).default
    }
    return cachedConfig
  } catch (error) {
    console.warn(
      `Failed to load config for ${environment}, using development`,
      error
    )
    return await import(`./prod.json`)
  }
}

export async function getApiBaseUrl(): Promise<string> {
  const runtimeConfig = useRuntimeConfig()

  if (import.meta.server && runtimeConfig.apiHost) {
    return runtimeConfig.apiHost
  }

  if (runtimeConfig.public.apiHost) {
    return runtimeConfig.public.apiHost
  }

  const config = await loadEnvironmentConfig()

  return config.API_URL
}

export function getEnvironmentConfig(): EnvironmentConfig | null {
  return cachedConfig
}
